import { HttpInterceptor, HttpRequest, HttpHandler } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { AuthService } from './auth.service';
import { environment } from 'src/environments/environment';

@Injectable()
export class AuthInterceptor implements HttpInterceptor {

    constructor(
        private authenticationService: AuthService
    ) { }

    intercept(req: HttpRequest<any>, next: HttpHandler) {
        let request = req.clone({
            headers: req.headers.set('X-API-KEY', environment.apiKey)
        });

        const isLoginCall = req.url === `${environment.apiBaseUrl}/courier/login-with-code`;
        if (isLoginCall) return next.handle(request);

        const authToken = this.authenticationService.getAuthorizationToken();
        if (authToken) {
            request = request.clone({
                headers: request.headers.set('X-AUTH-TOKEN', authToken)
            });
        }

        return next.handle(request);
    }
}
